import { FunctionComponent } from "react"
import Image from "next/image"

const DownloadPdfWidget: FunctionComponent = () => {
  return (
    <div className="flex py-2 px-4 bg-gradient-to-br from-[#FFF4CB] to-[#F8F8FF] items-center rounded-lg">
      <Image
        src= {`${process.env.CDN_URL}/assets/images/ielts/ielts-demo/pdf.svg`}
        alt="pdf"
        width={34}
        height={34}
      />
      <div className="pl-2 md:pl-4">
        <div className="text-[#824710] pr-1 md:pr-2 text-[14px]">
          Demo Booking Bonus:
        </div>
        <div className="text-[#532D0A] font-bold">Free IELTS resource book</div>
      </div>
    </div>
  )
}
export default DownloadPdfWidget
